module.exports = __webpack_public_path__ + "static/media/BR.04de9ebf.svg";